module.exports = __webpack_public_path__ + "img/tuiguang2-1-3.3e8487d3.png";